import { useRef } from "react";

export default function SearchBar({ value, onChange, loading, placeholder = "Search by name, company, industry, school..." }) {
  const inputRef = useRef(null);

  return (
    <div className="search-bar-wrapper">
      <span className="search-bar-icon">
        {loading ? (
          <span className="spinner-sm" />
        ) : (
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <circle cx="6.5" cy="6.5" r="5" stroke="var(--color-text-tertiary)" strokeWidth="1.5" />
            <path d="M10.5 10.5L14 14" stroke="var(--color-text-tertiary)" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        )}
      </span>
      <input
        ref={inputRef}
        className="search-bar-input"
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete="off"
        spellCheck={false}
      />
      {value && (
        <button
          className="search-bar-clear"
          onClick={() => { onChange(""); inputRef.current?.focus(); }}
          aria-label="Clear search"
        >
          ×
        </button>
      )}
    </div>
  );
}
